import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { ComputedShift } from '@/hooks/useShifts';
import type { ClockTime } from '@/types';

interface ShiftItemProps {
  shift: ComputedShift;
  clockTime?: ClockTime;
  onClick?: () => void;
}

function formatTime(iso: string): string {
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

export function ShiftItem({ shift, clockTime, onClick }: ShiftItemProps) {
  const { t } = useTranslation('shifts');

  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: shift.color,
        color: 'common.white',
        borderRadius: 1,
        px: 1,
        py: 0.25,
        height: '100%',
        cursor: onClick ? 'pointer' : 'default',
        overflow: 'hidden',
        border: shift.isOverridden ? '2px dashed rgba(255,255,255,0.6)' : 'none',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '&:hover': onClick
          ? { filter: 'brightness(0.9)' }
          : undefined,
      }}
    >
      <Typography variant="caption" fontWeight={600} lineHeight={1.3}>
        {shift.startTime} - {shift.endTime}
      </Typography>
      {clockTime && (clockTime.clockIn || clockTime.clockOut) && (
        <Typography
          variant="caption"
          lineHeight={1.2}
          sx={{ opacity: 0.85, fontSize: '0.65rem' }}
        >
          {clockTime.clockIn && `${t('clockedIn')} ${formatTime(clockTime.clockIn)}`}
          {clockTime.clockIn && clockTime.clockOut && ' — '}
          {clockTime.clockOut && `${t('clockedOut')} ${formatTime(clockTime.clockOut)}`}
        </Typography>
      )}
    </Box>
  );
}
